import { requireAuth } from '@/auth/requireAuth'
import { MonthSelectorWrapper } from '@/components/month-selector-wrapper'
import { ActivitySummary } from '@/components/summary/activity-summary'
import { InsightData } from '@/components/summary/insight-data'
import { SummaryFilters } from '@/components/summary/summary-filters'
import { PageTitle } from '@/layout/page-title'
import { getTasksProps } from '@/tasks'
import { getClosingDate } from '@/utils/closing-date'
import { createFileRoute, useLoaderData, useSearch } from '@tanstack/react-router'

type SummarySearch = {
  month: number
  year: number
  overdue?: boolean
  source: 'personal' | 'team'
  sapCode?: string
}


export const Route = createFileRoute('/(app)/_layout/summary')({
  component: RouteComponent,
  validateSearch: (search: Record<string, unknown>): SummarySearch => {
    // validate and parse the search params into a typed state
    const closingDate = getClosingDate();
    return {
      month: search.month as number ?? closingDate.month, // Default to current month if not provided
      year: search.year as number ?? closingDate.year,
      overdue: search.overdue as boolean ?? false, // Default to false if not provided
      //@ts-ignore
      source: search.source?.toString() ?? 'personal',
      sapCode: search.sapCode as string,
    }
  },
  beforeLoad: async () => await requireAuth(),
  loader: async () => {
    const {data: propsData, error }  = await getTasksProps();
    if (error) {
      console.error("Error loading summary data:", error);
      throw new Error("Failed to load summary data: " + error);
    }
    return { props: propsData };
  },
  staleTime: 1000 * 60 * 5, // 5 minutes
})

function RouteComponent() {

  const { roleData, companiesData } = useLoaderData({ from: '/(app)/_layout' })
  const { props: taskProps } = useLoaderData({ from: '/(app)/_layout/summary' });
  const { month, year, source, sapCode } = useSearch({ from: '/(app)/_layout/summary' });
  return (
    <div className="container max-w-[1900px] py-4 px-4 mx-auto">
      <div className="space-y-4">
        <PageTitle title="Summary" rightActions={
          <div className="flex items-center gap-4">
            <div>
              <SummaryFilters
                source={source}
                roles={roleData.data!}
                companies={companiesData.data ?? []} />
            </div>
            <div className="max-w-[350px]">
              <MonthSelectorWrapper initialMonth={month} initialYear={year} />
            </div>
          </div>
        } />
        
        <InsightData
          source={source}
          month={month}
          year={year}
          companySapCode={sapCode}
        />
        
        {
          (roleData.data?.isPm || roleData.data?.isOperator) &&
          <ActivitySummary
            taskProps={taskProps!}
            source={source}
            month={month}
            year={year}
            // companySapCode={sapCode}
          />
        }
      </div>
    </div>
  )
}
